import { ReactElement } from 'react'

export const isString = (value: unknown): value is string => typeof value === 'string'

export const isParsableDate = (value: unknown): value is string | Date => {
  try {
    const date =
      typeof value === 'string' || typeof value === 'number' ? new Date(value) : value
    return date instanceof Date && !isNaN(date.valueOf())
  } catch (e) {
    return false
  }
}

export const isReactElement = (child: unknown): child is ReactElement<any> =>
  !!child && typeof child === 'object' && child !== null && 'props' in child

export const notEmpty = <TValue>(value: TValue | null | undefined): value is TValue =>
  value !== null && value !== undefined
